var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { attrs: { "data-qa": "core_file_picker" } },
    [
      _c(_setup.CaptureTypeList, {
        on: { "choice-capture": _setup.handleChoiceCapture },
        model: {
          value: _setup.isOpenedCaptureTypeList,
          callback: function ($$v) {
            _setup.isOpenedCaptureTypeList = $$v
          },
          expression: "isOpenedCaptureTypeList",
        },
      }),
      _vm._v(" "),
      _c(
        "label",
        {
          staticClass: "outline-none",
          attrs: { disabled: _vm.disabled, tabindex: _vm.disabled ? -1 : 0 },
          on: {
            click: _setup.open,
            blur: _setup.handleBlur,
            focus: _setup.handleFocus,
            keydown: _setup.handleKeydown,
          },
        },
        [
          _vm._t("default", null, {
            focused: _setup.isFocused,
            blured: _setup.isBlured,
            disabled: _vm.disabled,
          }),
          _vm._v(" "),
          _c("input", {
            ref: "coreFilePickerRef",
            staticClass: "file-input",
            attrs: {
              "data-qa": "core_file_picker_input",
              type: "file",
              accept: _setup.accept,
              capture: _setup.capture,
              disabled: "",
            },
            on: { change: _setup.handleSelectedFile },
          }),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }